<template>
  <div class="main-stage" @click.stop>
    <button class="stage-close" @click="emits('dismiss')" :aria-label="t('close')">
      <v-icon :icon="CloseIcon" size="16"/>
    </button>
    <button class="pill-btn pill-btn--demo" @click="handleDemo">
      {{ t('demo') }}
    </button>
    <button class="pill-btn pill-btn--support" @click="emits('support')">
      {{ t('support') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from '@/shared/lib/i18n';

import CloseIcon from '@/shared/ui/icons/action/Close.vue';

interface IEmits {
  (e: 'demo'): void;
  (e: 'support'): void;
  (e: 'dismiss'): void;
}

const emits = defineEmits<IEmits>();

const {t} = useI18n();

const handleDemo = () => {
  emits('demo');
  console.log('handleDemo');
}
</script>

<style scoped>
.main-stage {
  position: fixed;
  bottom: 7.375rem;
  right: 2.5rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.6875rem;
  width: 268px;
  max-width: calc(100vw - 5rem);
}

.stage-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  transition: background-color 0.2s;
  color: var(--BW-800);

  &:hover {
    background: var(--BW-100);
  }
}

.pill-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 59px;
  background: var(--surface);
  border: 1px solid var(--BW-400);
  font-size: 0.875rem;
  line-height: normal;
  color: var(--BW-800);
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background: var(--BW-100);
  }
}

.pill-btn--support {
  width: 100%;
}

@media (max-width: 1280px) {
  .main-stage {
    bottom: calc(8rem + var(--chat-widget-bottom));
    right: 1.25rem;
    width: 268px;
    max-width: calc(100vw - 2.5rem);
  }
}

@media (max-width: 600px) {
  .main-stage {
    display: none;
  }
}
</style>

<i18n lang="json">
{
  "ru": {
    "demo": "Заказать демонстрацию",
    "support": "Связаться со службой поддержки",
    "close": "Закрыть"
  },
  "kk": {
    "demo": "Демонстрацияға тапсырыс беру",
    "support": "Қолдау қызметімен байланысу",
    "close": "Жабу"
  },
  "en": {
    "demo": "Request a demo",
    "support": "Contact support",
    "close": "Close"
  }
}
</i18n>
